<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Kullanıcı Yönetimi</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field v-model="search" append-icon="search" label="Ara" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="showAddDialog" class="mb-2">
        <v-icon left>add</v-icon>
        Yeni Kullanıcı Ekle
      </v-btn>
    </v-toolbar>
    
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="users"
      :search="search"
      :rows-per-page-items="pageItems"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.username }}</td>
        <td class="text-xs-center">{{ props.item.firstName }}</td>
        <td class="text-xs-center">{{ props.item.lastName }}</td>
        <td class="text-xs-center">{{ props.item.username === "admin"?"admin" : (props.item.role || 'User') }}</td>
        <td class="text-xs-center">
          <v-icon small class="mr-2" @click="editUser(props.item)" color="blue">edit</v-icon>
          <v-icon small @click="deleteUser(props.item)" color="red">delete</v-icon>
        </td>
      </template>
    </v-data-table>

    <!-- Kullanıcı Ekleme/Düzenleme Dialog -->
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedIndex === -1 ? 'Yeni Kullanıcı' : 'Kullanıcı Düzenle' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md12>
                <v-text-field v-model="editedItem.username" label="Kullanıcı Adı" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field v-model="editedItem.firstName" label="Ad" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field v-model="editedItem.lastName" label="Soyad" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md12>
                <v-text-field 
                  v-model="editedItem.password" 
                  label="Şifre" 
                  type="password"
                  :hint="editedIndex !== -1 ? 'Değiştirmek istemiyorsanız boş bırakın' : ''"
                  persistent-hint
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">İptal</v-btn>
          <v-btn color="blue darken-1" text @click="saveUser" :loading="saving">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Silme Onay Dialog -->
    <v-dialog v-model="deleteDialog" max-width="350px">
      <v-card>
        <v-card-title class="headline">Kullanıcıyı Sil</v-card-title>
        <v-card-text>Bu kullanıcıyı silmek istediğinizden emin misiniz?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false">İptal</v-btn>
          <v-btn color="red darken-1" text @click="confirmDelete" :loading="deleting">Sil</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { userService } from "@/_services";

export default {
  data() {
    return {
      users: [],
      loading: false,
      saving: false,
      deleting: false,
      search: '',
      dialog: false,
      deleteDialog: false,
      editedIndex: -1,
      editedItem: {
        username: '',
        firstName: '',
        lastName: '',
        password: ''
      },
      defaultItem: {
        username: '',
        firstName: '',
        lastName: '',
        password: ''
      },
      userToDelete: null,
      pagination: {
        sortBy: 'id'
      },
      pageItems: [
        10,
        25,
        50,
        { text: 'Tümü', value: -1 }
      ],
      headers: [
        { text: 'ID', value: 'id', align: 'center' },
        { text: 'Kullanıcı Adı', value: 'username', align: 'center' },
        { text: 'Ad', value: 'firstName', align: 'center' },
        { text: 'Soyad', value: 'lastName', align: 'center' },
        { text: 'Rol', value: 'role', align: 'center' },
        { text: 'İşlemler', value: 'actions', sortable: false, align: 'center' }
      ]
    };
  },
  created() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loading = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_API}/api/users`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        this.users = await response.json();
      } catch (error) {
        console.error('Kullanıcılar yüklenirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'Kullanıcılar yüklenirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.loading = false;
      }
    },
    showAddDialog() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },
    editUser(user) {
      this.editedIndex = this.users.indexOf(user);
      this.editedItem = Object.assign({}, user);
      this.editedItem.password = ''; // Şifreyi boş bırak
      this.dialog = true;
    },
    deleteUser(user) {
      this.userToDelete = user;
      this.deleteDialog = true;
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async saveUser() {
      this.saving = true;
      try {
        const userData = { ...this.editedItem };
        
        // Şifre boşsa ve düzenleme modundaysa şifreyi çıkar
        if (!userData.password && this.editedIndex !== -1) {
          delete userData.password;
        }
        
        if (this.editedIndex > -1) {
          // Güncelleme
          await fetch(`${process.env.VUE_APP_API}/api/users/${userData.id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
            },
            body: JSON.stringify(userData)
          });
          
          Object.assign(this.users[this.editedIndex], userData);
        } else {
          // Yeni ekleme
          const response = await fetch(`${process.env.VUE_APP_API}/api/users/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
            },
            body: JSON.stringify(userData)
          });
          
          if (response.ok) {
            this.loadUsers(); // Listeyi yenile
          }
        }
        
        this.closeDialog();
        this.$store.commit('SET_MESSAGE', 'Kullanıcı başarıyla kaydedildi');
        this.$store.commit('SET_DIALOG', true);
      } catch (error) {
        console.error('Kullanıcı kaydedilirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'Kullanıcı kaydedilirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.saving = false;
      }
    },
    async confirmDelete() {
      this.deleting = true;
      try {
        await fetch(`${process.env.VUE_APP_API}/api/users/${this.userToDelete.id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('currentUser')).token}`
          }
        });
        
        const index = this.users.indexOf(this.userToDelete);
        this.users.splice(index, 1);
        
        this.deleteDialog = false;
        this.$store.commit('SET_MESSAGE', 'Kullanıcı başarıyla silindi');
        this.$store.commit('SET_DIALOG', true);
      } catch (error) {
        console.error('Kullanıcı silinirken hata:', error);
        this.$store.commit('SET_MESSAGE', 'Kullanıcı silinirken hata oluştu');
        this.$store.commit('SET_DIALOG', true);
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 20px;
}
</style>
